import { useSingleBrand } from "@/features/brands/hooks/useSingleBrand";
import { useSingleEvent } from "@/features/events/hooks/useSingleEvent";
import { Job } from "@/models/Job.model";
import { FC, JSX } from "react";
import JobOverviewListItem from "./job.overview.list.item";
import { Spinner } from "@radix-ui/themes";

const JobOverviewListItemFetcher: FC<Job> = ({ ...props }): JSX.Element => {
  const {
    data: brand,
    loading: loadingBrand,
    error: errorBrand,
  } = useSingleBrand(props.brand);
  const {
    data: event,
    loading: loadingEvent,
    error: errorEvent,
  } = useSingleEvent(props.event);

  if (loadingBrand || loadingEvent) {
    return <Spinner />;
  }

  if (errorBrand || errorEvent) {
    const error = errorBrand || errorEvent;
    return <>Error: {error?.message}</>;
  }

  if (props && brand && event) {
    return <JobOverviewListItem job={props} brand={brand} event={event} />;
  }

  return <>Something went wrong</>;
};

export default JobOverviewListItemFetcher;
